import { useGeoLocation } from "@/components/features/items/edit/_shared/ui/components/main/questions/address/geo-location/hooks/use-get-location";

import { useProductRoomFormModelContext } from "../../../../context";

export const useRoomGeoLocation = () => {
	const { viewModel, onSetViewModel } = useProductRoomFormModelContext();
	const { geoLocation } = viewModel;

	return {
		...useGeoLocation({ geoLocation, onSetViewModel }),
	};
};
